const ArrowDownIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.60156 1L9.60156 8.91752L17.6016 1"
        stroke="#0099CC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowDownIcon;
